<app-toolbar [title]="'Angular Components'">
  <ul>
    <li
      routerLink=""
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      Components
    </li>
    <li routerLink="directives" routerLinkActive="active">Directives</li>
    <li routerLink="services" routerLinkActive="active">Services</li>
    <li routerLink="pipes" routerLinkActive="active">Pipes</li>
    <li routerLink="other" routerLinkActive="active">Other</li>
  </ul>
</app-toolbar>

<main>
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

<app-snackbar></app-snackbar>
